import { QueryClient } from '@tanstack/react-query';
import { map } from 'lodash';

// Query roots whose responses are derived from slide channel-to-marker assignments.
export const MARKER_ASSIGNMENT_DEPENDENT_QUERY_ROOTS = [
  'multiplex_marker_types',
  'multiplex_source_channels',
  'multiplex_panels',
  'pendingSlide',
  'multiplexActionSelectionSlides',
  'slides',
  'procedures',
  'procedure',
  'studyPipelineStatus',
  'multiplexNormalizationSummary',
  'bulkMultiplexNormalizationSummary',
  'multiplexBinaryClassifierNormalizationSummary',
  'blobSegmentationNormalizationSummary',
  'peakDetectionNormalizationSummary',
  'study-marker-qc-summary',
  'study-marker-qc-barcode',
  'study-marker-normalization-summary',
] as const;

/** Call after any marker-name write so workflow, QC, and action-form views refetch the new assignments. */
export const invalidateMarkerAssignmentQueries = (queryClient: QueryClient) =>
  Promise.all(
    map(MARKER_ASSIGNMENT_DEPENDENT_QUERY_ROOTS, (root) => queryClient.invalidateQueries({ queryKey: [root] }))
  );
